import React, { Suspense, useContext, useEffect, useRef } from 'react';
import 'twin.macro';
import { Main } from '../sections';
import { SideBarComments } from '../sidebars';
import { AppContext, RouterContext } from '../context';
import { ItemContext, ItemContextProvider, ItemDetails } from '../item';
import { Loading } from '../loading';

export const ItemDetailsPage = ({ overWriteItemId, ...props }) => {
  return (
    <Suspense fallback={<Loading />}>
      <ItemContextProvider overWriteItemId={overWriteItemId}>
        <ItemDetailsPageWithoutContext {...props} />
      </ItemContextProvider>
    </Suspense>
  );
};

const SideBarBlock = ({ nextPlaylistItem, hideAds }) => {
  const { twitchLiveStream, windowSize } = useContext(AppContext);

  const { item: currentItem } = useContext(ItemContext);

  return (
    <>
      {currentItem && (
        <>
          {(['DESKTOP'].includes(windowSize.adBreakPoint) ||
            nextPlaylistItem ||
            twitchLiveStream) && <SideBarComments hideAds={hideAds} />}
        </>
      )}
    </>
  );
};

export const ItemDetailsPageWithoutContext = ({
  hideSuggestions,
  isModal,
  nextPlaylistItem,
  ...restProps
}) => {
  const { isPrevItem } = useContext(RouterContext);

  // const newItemId = route ? hasId(route.to, route.from) : '';
  const {
    item: { nsfw, nopreroll },
    currentItemId,
  } = useContext(ItemContext);
  const hideAds = nsfw || nopreroll;

  const elRef = useRef();

  useEffect(() => {
    if (currentItemId && isModal && isPrevItem) {
      elRef.current.scrollIntoView({
        behavior: 'instant',
        block: 'end',
      });
    }
  }, [currentItemId, isModal, isPrevItem]);

  return (
    <Main
      SideBar={SideBarBlock({ nextPlaylistItem, hideAds })}
      noMaxWidth
      detailPage
      isModal={isModal}
      showAds={!hideAds}
      currentItemId={currentItemId}
      {...restProps}
    >
      <div ref={elRef}></div>
      <ItemDetails
        hideSuggestions={hideSuggestions}
        nextPlaylistItem={nextPlaylistItem}
        hideAds={hideAds}
      />
    </Main>
  );
};
